var _rect, _circle, _path, _path2, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOfficersArena(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 520,
    fill: "#101827"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 650,
    cy: 110,
    r: 150,
    fill: "#1d4ed8",
    opacity: 0.35
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 390h620M140 390V210h110v180M345 390V145h110v245M550 390V245h110v145",
    fill: "none",
    stroke: "#60a5fa",
    strokeWidth: 14
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M180 180l115-70 115 70-115 70z",
    fill: "#fbbf24",
    stroke: "#fde68a",
    strokeWidth: 8
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 95,
    fill: "#dbeafe",
    fontFamily: "sans-serif",
    fontSize: 36,
    fontWeight: 700
  }, "OFFICERS ARENA")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 465,
    fill: "#93c5fd",
    fontFamily: "monospace",
    fontSize: 22
  }, "ADAPTIVE EXAM INTELLIGENCE")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficersArena);
export default __webpack_public_path__ + "static/media/officers-arena.e1f308b7723ed22194c3bd95580318f5.svg";
export { ForwardRef as ReactComponent };